// @flow
import type { Dispatch } from 'redux';
import { ADD_CONFIG_BUILDER } from './constants';
import { generateSlug } from '../../../helpers';
import type { ACFConfigBuilder } from '../../../types/acf';
import type { AddConfigBuilder, ConfigBuilder } from './types';

// the function below adds a header ID in the configBuilder
const addIdToConfigHeaders = (configBuilder: ACFConfigBuilder): ConfigBuilder => (
  configBuilder.map(group => ({
    ...group,
    id: generateSlug(group.header || ''),
  }))
);

export const addConfigBuilder = (configBuilder: ConfigBuilder): AddConfigBuilder => ({
  type: ADD_CONFIG_BUILDER,
  configBuilder,
});

export const receiveConfigBuilder = (configBuilder: ACFConfigBuilder) => (
  dispatch: Dispatch<*>,
) => {
  const configBuilderWithHeaderIds = addIdToConfigHeaders(configBuilder);
  dispatch(addConfigBuilder(configBuilderWithHeaderIds));
};
